import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

/** Иконка инструмента «Ai GROW» (модель GROW) для панели видеокомнаты */
export const GrowAiIcon: FC<IconProps> = ({ width = 48, height = 48, fillBg = '#828282', fill = '#fff' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="10" fill={fillBg} />
      <path
        d="M24 14C18.477 14 14 18.477 14 24C14 29.523 18.477 34 24 34C29.523 34 34 29.523 34 24C34 18.477 29.523 14 24 14ZM24 16C28.418 16 32 19.582 32 24C32 28.418 28.418 32 24 32C19.582 32 16 28.418 16 24C16 19.582 19.582 16 24 16Z"
        fill={fill}
        fillOpacity="0.85"
      />
      <path
        d="M24 19C21.239 19 19 21.239 19 24C19 26.761 21.239 29 24 29C26.761 29 29 26.761 29 24C29 21.239 26.761 19 24 19ZM24 21C25.657 21 27 22.343 27 24C27 25.657 25.657 27 24 27C22.343 27 21 25.657 21 24C21 22.343 22.343 21 24 21Z"
        fill={fill}
        fillOpacity="0.85"
      />
      <circle cx="24" cy="24" r="2" fill={fill} fillOpacity="0.95" />
      <path
        d="M24 11V13M24 35V37M37 24H35M13 24H11M33.485 14.515L32.071 15.929M15.929 32.071L14.515 33.485M33.485 33.485L32.071 32.071M15.929 15.929L14.515 14.515"
        stroke={fill}
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
